import { defineMessages } from 'react-intl';
import { PROCEDURE_IDS } from '@zocdoc/components/src/constants';
import PhysicalImage from './assets/annualphysical-desktop.svg';
import DentalImage from './assets/dentalcleaning-desktop.svg';
import SkinImage from './assets/skinscreening-desktop.svg';
import VisionImage from './assets/visionexam-desktop.svg';
import MobilePhysicalImage from './assets/annualphysical-mobile.svg';
import MobileDentalCleaningImage from './assets/dentalcleaning-mobile.svg';
import MobileSkinScreeningImage from './assets/skinscreening-mobile.svg';
import MobileVisionExamImage from './assets/visionexam-mobile.svg';

export const INCOMPLETE_TASKS_THRESHOLD = 2;
export const MOBILE_INCOMPLETE_TASKS_THRESHOLD = 1;

export const MOBILE_IMAGES = {
    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: MobilePhysicalImage,
    [PROCEDURE_IDS.DENTAL_CLEANING]: MobileDentalCleaningImage,
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: MobileSkinScreeningImage,
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: MobileVisionExamImage,
};

export const LOCALIZED_STRINGS = defineMessages({
    MobileHeaderTitle: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Header.Title',
        defaultMessage: 'It\'s a new year!',
    },
    Physical: {
        id: 'Components.JanuaryWellnessGuide.Physical',
        defaultMessage: 'Annual physical',
    },
    Dental: {
        id: 'Components.JanuaryWellnessGuide.Dental',
        defaultMessage: 'Dental cleaning',
    },
    Skin: {
        id: 'Components.JanuaryWellnessGuide.Skin',
        defaultMessage: 'Skin screen',
    },
    Vision: {
        id: 'Components.JanuaryWellnessGuide.Vision',
        defaultMessage: 'Vision exam',
    },
    PhysicalButton: {
        id: 'Components.JanuaryWellnessGuide.Button.Physical',
        defaultMessage: 'Book a physical',
    },
    DentalButton: {
        id: 'Components.JanuaryWellnessGuide.Button.Dental',
        defaultMessage: 'Book a dental cleaning',
    },
    SkinButton: {
        id: 'Components.JanuaryWellnessGuide.Button.Skin',
        defaultMessage: 'Book a skin screen',
    },
    VisionButton: {
        id: 'Components.JanuaryWellnessGuide.Button.Vision',
        defaultMessage: 'Book a vision exam',
    },
    MobilePhysicalButton: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Button.Physical',
        defaultMessage: 'Book physical',
    },
    MobileDentalButton: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Button.Dental',
        defaultMessage: 'Book cleaning',
    },
    MobileSkinButton: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Button.Skin',
        defaultMessage: 'Book screening',
    },
    MobileVisionButton: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Button.Vision',
        defaultMessage: 'Book exam',
    },
    ViewWellnessGuideButton: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Button.ViewWellnessGuide',
        defaultMessage: 'View Well Guide',
    },
    HeaderTitle: {
        id: 'Components.JanuaryWellnessGuide.Header.Title',
        defaultMessage: 'Start the new year with a fresh bill of health!',
    },
    HeaderMessage: {
        id: 'Components.JanuaryWellnessGuide.Header.Message',
        defaultMessage: 'Complete your New Year\'s resolution early by booking your 2019 preventive care today.',
    },
    MobilePhysicalDescription: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Physical.Description',
        defaultMessage: 'Seeing a doctor isn\'t only for when you\'re sick. The CDC recommends regular checkups on your vitals, vaccinations, & weight.',
    },
    PhysicalDescription1: {
        id: 'Components.JanuaryWellnessGuide.Physical.Description1',
        defaultMessage: 'Seeing a doctor isn\'t only for when you\'re sick. The ',
    },
    PhysicalDescription2: {
        id: 'Components.JanuaryWellnessGuide.Physical.Description2',
        defaultMessage: ' recommends regular checkups on your vitals, vaccinations, & weight.',
    },
    PhysicalReferer: {
        id: 'Components.JanuaryWellnessGuide.Physical.Referer',
        defaultMessage: 'CDC',
    },
    PhysicalRefererHover: {
        id: 'Components.JanuaryWellnessGuide.Physical.Referer.Hover',
        defaultMessage: 'Centers for Disease Control and Prevention',
    },
    MobileDentalDescription: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Dental.Description',
        defaultMessage: 'The American Dental Association recommends a cleaning twice a year. Click, smile, & repeat!',
    },
    DentalDescription: {
        id: 'Components.JanuaryWellnessGuide.Dental.Description',
        defaultMessage: 'The American Dental Association recommends a cleaning twice a year. Click, smile, & repeat!',
    },
    MobileSkinDescription: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Skin.Description',
        defaultMessage: 'According to the ACS, skin cancer is one of the most common cancers, and early detection can be key to treatment.',
    },
    SkinDescription1: {
        id: 'Components.JanuaryWellnessGuide.Skin.Description1',
        defaultMessage: 'According to the ',
    },
    SkinDescription2: {
        id: 'Components.JanuaryWellnessGuide.Skin.Description2',
        defaultMessage: ', skin cancer is one of the most common cancers, and early detection can be key to treatment.',
    },
    SkinReferer: {
        id: 'Components.JanuaryWellnessGuide.Skin.Referer',
        defaultMessage: 'ACS',
    },
    SkinRefererHover: {
        id: 'Components.JanuaryWellnessGuide.Skin.Referer.Hover',
        defaultMessage: 'American Cancer Society',
    },
    MobileVisionDescription: {
        id: 'Components.JanuaryWellnessGuide.Mobile.Vision.Description',
        defaultMessage: 'Even people with 20/20 vision need regular checkups. According to the AAO, eye exams can help identify risk of eye diseases early.',
    },
    VisionDescription1: {
        id: 'Components.JanuaryWellnessGuide.Vision.Description1',
        defaultMessage: 'Even people with 20/20 vision need regular checkups. According to the ',
    },
    VisionDescription2: {
        id: 'Components.JanuaryWellnessGuide.Vision.Description2',
        defaultMessage: ', eye exams can help identify risk of eye diseases early.',
    },
    VisionReferer: {
        id: 'Components.JanuaryWellnessGuide.Vision.Referer',
        defaultMessage: 'AAO',
    },
    VisionRefererHover: {
        id: 'Components.JanuaryWellnessGuide.Vision.Referer.Hover',
        defaultMessage: 'American Academy of Ophthalmology',
    },
});

export const MOBILE_MESSAGES = {
    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: {
        type: LOCALIZED_STRINGS.Physical,
        buttonText: LOCALIZED_STRINGS.MobilePhysicalButton,
        description: LOCALIZED_STRINGS.MobilePhysicalDescription,
    },
    [PROCEDURE_IDS.DENTAL_CLEANING]: {
        type: LOCALIZED_STRINGS.Dental,
        buttonText: LOCALIZED_STRINGS.MobileDentalButton,
        description: LOCALIZED_STRINGS.MobileDentalDescription,
    },
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: {
        type: LOCALIZED_STRINGS.Skin,
        buttonText: LOCALIZED_STRINGS.MobileSkinButton,
        description: LOCALIZED_STRINGS.MobileSkinDescription,
    },
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: {
        type: LOCALIZED_STRINGS.Vision,
        buttonText: LOCALIZED_STRINGS.MobileVisionButton,
        description: LOCALIZED_STRINGS.MobileVisionDescription,
    },
};

const GA_EVENT_ACTION_PREFIX = 'January Wellness Guide';

export const GA_EVENT_ACTIONS = {
    CLICK_CANCEL_BUTTON: `${GA_EVENT_ACTION_PREFIX} - Clicked Cancel Button`,
    CLICK_OUTSIDE_MODAL: `${GA_EVENT_ACTION_PREFIX} - Clicked Outside Modal`,
};

export const MESSAGES = {
    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: {
        buttonText: LOCALIZED_STRINGS.PhysicalButton,
        description1: LOCALIZED_STRINGS.PhysicalDescription1,
        description2: LOCALIZED_STRINGS.PhysicalDescription2,
        referer: LOCALIZED_STRINGS.PhysicalReferer,
        refererHover: LOCALIZED_STRINGS.PhysicalRefererHover,
        type: LOCALIZED_STRINGS.Physical,
    },
    [PROCEDURE_IDS.DENTAL_CLEANING]: {
        buttonText: LOCALIZED_STRINGS.DentalButton,
        description1: LOCALIZED_STRINGS.DentalDescription,
        type: LOCALIZED_STRINGS.Dental,
    },
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: {
        buttonText: LOCALIZED_STRINGS.SkinButton,
        description1: LOCALIZED_STRINGS.SkinDescription1,
        description2: LOCALIZED_STRINGS.SkinDescription2,
        referer: LOCALIZED_STRINGS.SkinReferer,
        refererHover: LOCALIZED_STRINGS.SkinRefererHover,
        type: LOCALIZED_STRINGS.Skin,
    },
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: {
        buttonText: LOCALIZED_STRINGS.VisionButton,
        description1: LOCALIZED_STRINGS.VisionDescription1,
        description2: LOCALIZED_STRINGS.VisionDescription2,
        referer: LOCALIZED_STRINGS.VisionReferer,
        refererHover: LOCALIZED_STRINGS.VisionRefererHover,
        type: LOCALIZED_STRINGS.Vision,
    },
};

export const IMAGES = {
    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: PhysicalImage,
    [PROCEDURE_IDS.DENTAL_CLEANING]: DentalImage,
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: SkinImage,
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: VisionImage,
};

const recommendationPriority = {
    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: 0,
    [PROCEDURE_IDS.DENTAL_CLEANING]: 1,
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: 2,
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: 3,
};

export const sortRecommendations = (recommendation1, recommendation2) => {
    const procedureId1 = recommendation1.procedure_id;
    const procedureId2 = recommendation2.procedure_id;

    return recommendationPriority[procedureId1] - recommendationPriority[procedureId2];
};
